// The pure bits of a collapsed origin-fold row. Import-free on purpose: `TaskOriginGroup` is a
// component in the app's dependency graph, and a jest suite that reached it would drag common-lib's
// ESM chain in with it (see CLAUDE.md → Tests).

/** A task the header can be built from — only the fields the header reads. */
export interface DatedTask {
  updatedDate?: string | Date;
}

/** `updatedDate` as a sortable number; missing or unparseable sorts oldest, never crashes. */
function updatedMs(task: DatedTask): number {
  if (!task.updatedDate) return 0;
  const ms = new Date(task.updatedDate).getTime();
  return Number.isNaN(ms) ? 0 : ms;
}

/**
 * The run a collapsed group speaks for: the most recently updated one. Runs of a routine are
 * near-identical, so the newest is representative — and it is the only one whose title and stamp
 * a reader can check against the routine's last firing. Ties keep the list's own order.
 */
export function newestRun<T extends DatedTask>(tasks: T[]): T | undefined {
  let newest: T | undefined;
  for (const task of tasks) {
    if (!newest || updatedMs(task) > updatedMs(newest)) newest = task;
  }
  return newest;
}
